export default __webpack_public_path__ + "static/media/seven.8b23be13.jpg";